/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

interface PillProps {
  children: React.ReactNode;
}

export const Pill: React.FC<PillProps> = ({ children }) => {
  return (
    <span css={pillStyles}>
      {children}
    </span>
  );
};

const pillStyles = css`
  display: inline-flex;
  align-items: center;
  border-radius: 1rem;
  background: #f3f4f6;
  padding: 0.2rem 0.8rem;
  font-size: 1.1rem;
  color: #374151;
`;